import React, { useState } from "react";
import { Box, Typography, Paper, Snackbar, Alert } from "@mui/material";
import { useBrandRatingsQuery, useBrandRatingRubricsQuery, useCreateBrandRating } from "./hooks";
import BrandRatingsList from "./BrandRatingsList";
import BrandRatingGenerationForm from "./BrandRatingGenerationForm";
import BrandQuerySection from "./BrandQuerySection";

export default function BrandRatingSection({ brandId }) {
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const { data: ratingsData, isLoading: isLoadingRatings } = useBrandRatingsQuery(brandId);
  const { data: rubricsData, isLoading: isLoadingRubrics } = useBrandRatingRubricsQuery();
  const createBrandRating = useCreateBrandRating(brandId);

  const handleGenerateRating = async (brandRatingRubricId) => {
    try {
      await createBrandRating.mutateAsync(brandRatingRubricId);
      setSnackbar({
        open: true,
        message: "Brand rating created successfully! It will begin evaluating.",
        severity: "success"
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to create brand rating",
        severity: "error"
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Box mb={3}>
        <Typography variant="h3" gutterBottom>
          Brand Ratings
        </Typography>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Existing Ratings
          </Typography>
          <BrandRatingsList
            ratings={ratingsData?.ratings}
            isLoading={isLoadingRatings}
          />
        </Paper>

        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Generate New Rating
          </Typography>
          <BrandRatingGenerationForm
            rubrics={rubricsData?.rubrics}
            isLoadingRubrics={isLoadingRubrics}
            onGenerateRating={handleGenerateRating}
            isGenerating={createBrandRating.isPending}
          />
        </Paper>

        <BrandQuerySection brandId={brandId} />
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
